import { ENV } from '../../../config';

export const LEVEL_ADMIN_ROUTER = {
    list: `${ENV.apiUrl}/api/v1/admin/level`,
};
